import type { FetchFunction } from '#layers/base/public';

interface DeleteMembersOptions {
	ids: string[];
	workspaceFetch: FetchFunction;
}

export async function deleteMembers({ ids, workspaceFetch }: DeleteMembersOptions) {
	return workspaceFetch('members', {
		method: 'DELETE',
		body: JSON.stringify(ids.map((id) => ({ userId: id }))),
	});
}
